














































































































































































import Vue from 'vue'
import {
  BCard, BRow, BCol, BFormInput, BTable, BPagination,
  BDropdown, BDropdownItem, BButton, BLink,
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import TableSpinner from '@/views/components/table-spinner/TableSpinner.vue'
import pushStateFiltersParams from '@/helpers/pushStateFiltersParams'
import { appLettersList } from '@/store/modules/app-letters-list'

let debounceTimeout: ReturnType<typeof setTimeout> = setTimeout(() => '', 1000)

export default Vue.extend({
  name: 'LettersList',
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BButton,
    BLink,

    vSelect,

    TableSpinner,
  },
  data() {
    return {
      currentRouteName: this.$router.currentRoute.name,
    }
  },
  computed: {
    tableColumns() {
      return appLettersList.getters.getTableColumns
    },
    perPage() {
      return appLettersList.getters.getPerPage
    },
    totalItems() {
      return appLettersList.getters.getTotalItems
    },
    currentPage: {
      get() {
        return appLettersList.getters.getCurrentPage
      },
      set(val: number) {
        appLettersList.mutations.SET_CURRENT_PAGE(val)
      },
    },
    perPageOptions() {
      return appLettersList.getters.getPerPageOptions
    },
    searchQuery: {
      get() {
        return appLettersList.getters.getSearchQuery
      },
      set(val: string) {
        appLettersList.mutations.SET_SEARCH_QUERY(val)
      },
    },
    sortBy() {
      return appLettersList.getters.getSortBy
    },
    isSortDirDesc() {
      return appLettersList.getters.getIsSortDirDesc
    },
    dataMeta() {
      return appLettersList.getters.getDataMeta
    },
  },
  watch: {
    $route() {
      if (!this.$route.query.currentPage) {
        this.setFilterParams()
      }
      this.updateTable()
    },
    currentPage(val, prevVal) {
      if (val !== prevVal) {
        pushStateFiltersParams(this, this.currentRouteName, 'currentPage', val)
      }
    },
    perPage(val, prevVal) {
      if (val !== prevVal) {
        pushStateFiltersParams(this, this.currentRouteName, 'perPage', val)
      }
    },
    searchQuery(val, prevVal) {
      if (val !== prevVal) {
        clearTimeout(debounceTimeout)
        debounceTimeout = setTimeout(() => {
          pushStateFiltersParams(this, this.currentRouteName, 'searchQuery', val)
        }, 250)
      }
    },
  },
  mounted() {
    this.setFilterParams()
    // Update filters
    window.onpopstate = () => {
      this.setFilterParams()
    }
  },
  methods: {
    updatePerPage(val: number) {
      appLettersList.mutations.SET_PER_PAGE(val)
    },
    async fetchLettersList() {
      return appLettersList.actions.fetchLettersList()
    },
    updateTable() {
      (this.$refs.refLettersListTable as BTable).refresh()
    },
    async deleteItem(id: string) {
      await appLettersList.actions.deleteLetterTemplate(id)
      this.updateTable()
    },
    async cloneTemplate(id: string) {
      await appLettersList.actions.cloneLetterTemplate(id)
      this.updateTable()
    },
    setFilterParams() {
      appLettersList.mutations.SET_FILTER_PARAMS()
    },
  },
})
